export default __webpack_public_path__ + "c2c11f6ef8d89c6d49106fd192749b6a.jpg";